import { createContext } from 'react'
import { INumberInputContext } from './types'

export const NumberInputContext = createContext<INumberInputContext>(null!)
